import { useParams } from "react-router-dom";
import QuestionPreview from "./QuestionPreview/QuestionPreview";
import { Languages } from "../../Redux/reducers/studySlice";

const RegistryFormPreview = () => {
  const { formId } = useParams();
  const languages: Languages[] = [];
  return (
    <QuestionPreview
      formId={formId || ""}
      type="platform"
      languages={languages}
    />
  );
};

export default RegistryFormPreview;
